import {Timer} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React, {useEffect, useMemo} from "react";
import {Button, CheckBox, Column, Row, Text} from "react-vcomponents";
import {InfoButton, RunInAction_Set, useForceUpdate} from "web-vcore";
import {AlarmsComp} from "../../../../Engine/LiveSession/Components/AlarmsComp.js";
import {GetLiveSession_Reactive, StartHostSession, StopHostSession} from "../../../../Engine/LiveSessionManagement.js";
import {GetActivities} from "../../../../Server/DB/activities.js";
import {store} from "../../../../Store/index.js";
import {InDesktop} from "../../../../Utils/Bridge/Bridge_Native.js";
import {processId} from "../../../../Utils/Bridge/Bridge_RemoteUserProcesses.js";
import {SessionCompsStatusUIContainer} from "../../Journey/DropdownPanel/SessionInfoUI.js";
import {EngineConfigPanels_SharedProps} from "../ConfigPanel_Local.js";
import {Phase} from "../../../../Server/DB/@Shared/Phase.js";
import {MeID} from "../../../../Server/DB/users.js";

export const SessionManagementPanel_Local = observer_mgl((props: EngineConfigPanels_SharedProps)=>{
	const {active, config_full: config} = props;
	const uiState = store.main.engine.config;
	const liveSession = GetLiveSession_Reactive();
	const liveAlarmsComp = liveSession?.Comp(AlarmsComp);
	const activities = GetActivities(MeID());

	const forceUpdate = useForceUpdate();
	const self = useMemo(()=>({
		emptyBox: null as HTMLDivElement|n,
		statusRefreshTimer: new Timer(500, ()=>{
			if (liveSession) { //&& this.mounted) {
				forceUpdate();
			}
		}),
		onPointerLockChange: ()=>forceUpdate(),
		onPointerLockError: ()=>forceUpdate(),
	}), []);

	useEffect(()=>{
		self.statusRefreshTimer.Start();
		document.addEventListener("pointerlockchange", self.onPointerLockChange);
		document.addEventListener("pointerlockerror", self.onPointerLockError);
		return ()=>{
			self.statusRefreshTimer.Stop();
			document.removeEventListener("pointerlockchange", self.onPointerLockChange);
			document.removeEventListener("pointerlockerror", self.onPointerLockError);
		};
	}, []);

	const largeVersion = window.outerWidth >= 1024;
	const remoteSessionRunning = liveSession?.IsClient();
	return (
		<Column mb={40} style={{background: "hsla(0,0%,100%,.1)", borderRadius: 5, padding: 5}}>
			<Row>
				<Text style={{fontSize: 18}}>Session management</Text>
				<Text ml={5} sel style={{fontSize: 12, opacity: .5}}>(pid: {processId})</Text>
			</Row>

			<Row mt={5}>
				{!active && <>
					<Button text="Start (local)" enabled={config != null && !remoteSessionRunning} onClick={async()=>{
						StartHostSession("night");
					}}/>
					<Button ml={5} text="Start (local, daytime-mode)" enabled={config != null && !remoteSessionRunning} onClick={async()=>{
						StartHostSession("day");
					}}/>
					<InfoButton ml={5} text={`
						Daytime-mode disables certain features, like alarms. (affected options tinted light blue)
					`.AsMultiline(0)}/>
				</>}
				{active &&
				<>
					{InDesktop() &&
					<>
						<Button text="Stop (save local + online)" enabled={config != null && MeID() != null && !remoteSessionRunning} onClick={async()=>{
							StopHostSession(true, true);
						}}/>
						<Button ml={5} text="Stop (save local)" enabled={config != null && !remoteSessionRunning} onClick={async()=>{
							StopHostSession(true, false);
						}}/>
					</>}
					{!InDesktop() &&
					<>
						<Button text="Stop (save online)" enabled={config != null && MeID() != null && !remoteSessionRunning} onClick={async()=>{
							StopHostSession(false, true);
						}}/>
					</>}
					<Button ml={5} text="Stop (discard)" enabled={config != null && !remoteSessionRunning} onClick={async()=>{
						/*ShowMessageBox({
							title: "Delete session folder?", cancelButton: true,
							message: "Place this session's folder into the trash?",
							onOK: ()=>{
								StopHostSession(false, false);
							},
						});*/
						// this only puts it into the trash, so no need for confirm-box
						StopHostSession(false, false);
					}}/>
				</>}
				<CheckBox ml={10} text="Allow client connections" value={uiState.allowClientConnections} onChange={val=>RunInAction_Set(()=>uiState.allowClientConnections = val)}/>
			</Row>

			{liveSession &&
				<>
					<SessionCompsStatusUIContainer refreshInterval={500}/>
					<CheckBox mt={50} text="Lock mouse (esc to end)" value={document.pointerLockElement != null} onChange={val=>{
						if (val) {
							self.emptyBox!.requestPointerLock();
						} else {
							document.exitPointerLock();
						}
					}}/>
					<Button mt={5} text="Snooze (5m)" style={{height: 200}} enabled={liveAlarmsComp != null} onClick={()=>{
						//liveFBASession!.Comp(AlarmsComp).Snooze({logOverride: "Snoozing (on-screen button)"});
						//liveAlarmsComp!.SetSolveWaitDuration(5 * minuteInMS);
						liveAlarmsComp!.SetPhase(Phase.solving);
						liveAlarmsComp!.NotifySolveProgress(5 * 60);
					}}/>
					<div ref={c=>void(self.emptyBox = c)}/>
				</>}
		</Column>
	);
});